import type { BillingDocumentSource } from "./billing-documents/types";

export const BILLING_SOURCE_LABELS: Record<BillingDocumentSource, string> = {
  prescription: "Pharmacie (ordonnance)",
  prescription_partial: "Pharmacie (partiel)",
  consultation: "Consultations",
  laboratory: "Laboratoire",
  imaging: "Imagerie",
  emergency: "Urgences",
  hospitalization: "Hospitalisation",
  nursing: "Soins infirmiers",
  surgery: "Chirurgie / bloc",
  ambulance: "Ambulance",
  patient_consumables: "Consommables patient",
};

export const BILLING_SOURCE_OPTIONS = (
  Object.entries(BILLING_SOURCE_LABELS) as [BillingDocumentSource, string][]
).map(([value, label]) => ({ value, label }));

/** Ordre d'affichage dashboard finance — inclut la vente comptoir (hors facturation). */
export const REVENUE_TYPE_CATALOG: readonly string[] = [
  "Vente comptoir",
  BILLING_SOURCE_LABELS.prescription,
  BILLING_SOURCE_LABELS.prescription_partial,
  BILLING_SOURCE_LABELS.consultation,
  BILLING_SOURCE_LABELS.emergency,
  BILLING_SOURCE_LABELS.ambulance,
  BILLING_SOURCE_LABELS.hospitalization,
  BILLING_SOURCE_LABELS.nursing,
  BILLING_SOURCE_LABELS.surgery,
  BILLING_SOURCE_LABELS.laboratory,
  BILLING_SOURCE_LABELS.imaging,
  BILLING_SOURCE_LABELS.patient_consumables,
];
